/**
 * Especialidade do médico para UI — esconde placeholders de cadastro.
 */

const PLACEHOLDER_SPECIALTIES = new Set(['a definir', 'a definir.', 'n/a', 'na', '-']);

export function formatDoctorSpecialty(
  specialty?: string | null,
): string | null {
  const value = specialty?.trim();
  if (!value) return null;
  if (PLACEHOLDER_SPECIALTIES.has(value.toLowerCase())) return null;
  return value;
}
